import { Fragment } from 'react'
import clsx from 'clsx'

import {
  WORK_OPENING_NOTICE_TYPE_OPTIONS,
  type WorkOpeningNoticeType,
} from '../types'

interface Props {
  noticeType: WorkOpeningNoticeType
  onChange: (type: WorkOpeningNoticeType) => void
  disabled?: boolean
}

const NoticeTypeSegment: React.FC<Props> = ({ noticeType, onChange, disabled }) => {
  return (
    <div className='col-12 d-flex flex-column align-items-center mb-4'>
      <span className='text-gray-600 fs-7 fw-semibold text-uppercase mb-2'>
        ประเภทใบแจ้งเปิดงาน
      </span>
      <div
        className='border border-gray-300 rounded d-inline-flex align-items-stretch overflow-hidden bg-gray-100'
        role='group'
        aria-label='ประเภทใบแจ้งเปิดงาน'>
        {WORK_OPENING_NOTICE_TYPE_OPTIONS.map((option, index) => (
          <Fragment key={option.value}>
            {index > 0 && (
              <div
                className='border-start border-gray-300 flex-shrink-0'
                style={{ width: 1 }}
                aria-hidden='true'
              />
            )}
            <button
              type='button'
              className={clsx(
                'btn border-0 rounded-0 px-8 py-3 fs-6 fw-semibold text-nowrap',
                noticeType === option.value
                  ? 'bg-white text-primary shadow-sm'
                  : 'bg-transparent text-gray-600 hover:bg-gray-200 hover:text-gray-800'
              )}
              disabled={disabled}
              aria-pressed={noticeType === option.value}
              onClick={() => onChange(option.value)}>
              {option.label}
            </button>
          </Fragment>
        ))}
      </div>
    </div>
  )
}

export default NoticeTypeSegment
